import { NofomoThemeProvider } from '@mdlbeasts/nofomo.ui.web';
import { ReactNode } from 'react';

import { getDirection } from 'utils/i18n.utils';

import { SiteLocale } from 'constants/i18n.constants';
import { useEnhancedEffect } from 'hooks/useEnhancedEffect';
import { UIKitThemeConfigFonts } from 'theme/uikit';

interface Props {
  children: ReactNode;
  locale: SiteLocale;
}

const ThemeContext = ({ children, locale }: Props) => {
  const direction = getDirection(locale);

  useEnhancedEffect(() => {
    document.body.dir = direction;
  }, [direction]);

  return (
    <NofomoThemeProvider
      locale={locale}
      fontFamilyDefault="LamaSans"
      fonts={UIKitThemeConfigFonts}
    >
      {children}
    </NofomoThemeProvider>
  );
};

export default ThemeContext;
